"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function setCursor(_ref) {
  var cursorValue = _ref.cursorValue,
      className = _ref.className;
  var htmlEl = document.querySelector('html');

  if (!document.body || !htmlEl) {
    return;
  }

  htmlEl.className = className;
  document.body.setAttribute('style', cursorValue);
}

function setGlobalCursor(cursor) {
  setCursor({
    cursorValue: "cursor: ".concat(cursor, " !important"),
    className: 'reset-all-cursors'
  });
}

function resetGlobalCursor() {
  setCursor({
    cursorValue: 'cursor: \'\'',
    className: ''
  });
}

var _default = {
  set: setGlobalCursor,
  reset: resetGlobalCursor
};
exports.default = _default;